import { render, staticRenderFns } from "./CreatePortionModal.vue?vue&type=template&id=4973e12f&"
import script from "./CreatePortionModal.vue?vue&type=script&lang=ts&"
export * from "./CreatePortionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports